import * as React from "react";
import { cn } from "./utils";

const badgeVariants = {
  default: "border-transparent bg-primary text-primary-foreground",
  secondary: "border-transparent bg-primary/10 text-primary",
  destructive: "border-transparent bg-destructive/10 text-destructive",
  outline: "border-border/60 bg-white/5 text-foreground backdrop-blur-sm",
  success: "border-transparent bg-emerald-500/10 text-emerald-600",
  warning: "border-transparent bg-amber-500/10 text-amber-600",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof badgeVariants;
}

export const Badge = ({
  className,
  variant = "default",
  ...props
}: BadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
        badgeVariants[variant],
        className,
      )}
      {...props}
    />
  );
};
